import { TableCell, TableRow, Typography } from "@material-ui/core";

export default function RowTotales(props) {
    const { label, value, colSpan } = props;

    return (
        <TableRow>
            <TableCell colSpan={colSpan}>
                <Typography color="secondary" className="right">
                    {label}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography color="primary">{value}</Typography>
            </TableCell>
        </TableRow>
    );
}
